export default __webpack_public_path__ + "static/scores@992_2x-7bcb94c568c8b180206d29060856f270.png";